import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { FaTimes, FaPlus, FaMinus } from "react-icons/fa";
import '../styles/pages/ModalLoan.css';

export default function LoanspageModal({
    onSubmit,
    currentLoanData,
    isOpen,
    onClose,
    isCreatingNewLoan
}) {
    const [loanData, setLoanData] = useState(null);

    useEffect(() => {
        if (currentLoanData) {
            setLoanData(currentLoanData);
        } else if (isCreatingNewLoan) {
            setLoanData({
                loan_type: '',
                tabs: [{
                    subcategoryName: '',
                    brackets: [{
                        purpose: '',
                        interest_rate: [''],
                        tenure: '',
                        requirement: [''],
                        margin: ''
                    }]
                }]
            });
        }
    }, [currentLoanData, isCreatingNewLoan]);

    const handleInputChange = (tabIndex, bracketIndex, field, value) => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs[tabIndex].brackets[bracketIndex][field] = value;
        setLoanData(updatedLoanData);
    };

    const handleSubcategoryNameChange = (tabIndex, value) => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs[tabIndex].subcategoryName = value;
        setLoanData(updatedLoanData);
    };

    const handleAddInterestRate = (tabIndex, bracketIndex) => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs[tabIndex].brackets[bracketIndex].interest_rate.push('');
        setLoanData(updatedLoanData);
    };

    const handleRemoveInterestRate = (tabIndex, bracketIndex, interestIndex) => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs[tabIndex].brackets[bracketIndex].interest_rate.splice(interestIndex, 1);
        setLoanData(updatedLoanData);
    };

    const handleAddRequirement = (tabIndex, bracketIndex) => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs[tabIndex].brackets[bracketIndex].requirement.push('');
        setLoanData(updatedLoanData);
    };

    const handleRemoveRequirement = (tabIndex, bracketIndex, requirementIndex) => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs[tabIndex].brackets[bracketIndex].requirement.splice(requirementIndex, 1);
        setLoanData(updatedLoanData);
    };

    const handleAddSubcategory = () => {
        const updatedLoanData = { ...loanData };
        updatedLoanData.tabs.push({
            subcategoryName: '',
            brackets: [{
                purpose: '',
                interest_rate: [''],
                tenure: '',
                requirement: [''],
                margin: ''
            }]
        });
        setLoanData(updatedLoanData);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        // Sending only the necessary data: loan_type and tabs
        const response = await fetch('/api/loanspage', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                loan_type: loanData.loan_type,
                tabs: loanData.tabs
            })
        });

        const data = await response.json();

        if (response.ok) {
            console.log('Loan successfully created/updated:', data);
            onSubmit(data); // Pass the response to the parent
           
        } else {
            console.error('Error:', data.message);
        }

        onClose(); // Close the modal after submission
    };

    if (!loanData) return null;

    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            modal
            closeOnDocumentClick={false}
            contentStyle={{
                padding: '20px',
                width: '500px',
                backgroundColor: '#fff',
                overflow: 'hidden',
            }}
        >
            <div className="modal" style={{
                height: '75vh',
                minHeight: '100%',
                backgroundColor: 'var(--primary_bg)', 
                display: 'flex',            
                flexDirection: 'column',  
            }}>
                <a
                    className="close"
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#555',
                    }}
                >
                    <FaTimes />
                </a>

                <form onSubmit={handleFormSubmit} style={{ flex: 1, overflowY: 'auto' }}>
                    <h2>{isCreatingNewLoan ? "Create New Loan" : "Edit Loan Data"}</h2>

                    <div>
                        <label>Loan Type:</label>
                        <input
                            type="text"
                            value={loanData.loan_type}
                            onChange={(e) => setLoanData({ ...loanData, loan_type: e.target.value })}
                        />
                    </div>

                    {loanData.tabs.map((tab, tabIndex) => (
                        <div key={tabIndex}>
                            <div>
                                <label>Subcategory Name:</label>
                                <input
                                    type="text"
                                    value={tab.subcategoryName || ""}
                                    onChange={(e) => handleSubcategoryNameChange(tabIndex, e.target.value)}
                                    placeholder="Enter subcategory name"
                                />
                            </div>

                            {tab.brackets.map((bracket, bracketIndex) => (
                                <div key={bracketIndex}>
                                    <h3>Bracket {bracketIndex + 1}</h3>

                                    <div>
                                        <label>Purpose:</label>
                                        <input
                                            type="text"
                                            value={bracket.purpose}
                                            onChange={(e) =>
                                                handleInputChange(tabIndex, bracketIndex, "purpose", e.target.value)
                                            }
                                        />
                                    </div>

                                    <div>
                                        <label>Interest Rate(s):</label>
                                        {bracket.interest_rate.map((rate, interestIndex) => (
                                            <div key={interestIndex} style={{ display: 'flex', gap: '10px' }}>
                                                <input
                                                    type="text"
                                                    value={rate}
                                                    onChange={(e) =>
                                                        handleInputChange(
                                                            tabIndex,
                                                            bracketIndex,
                                                            "interest_rate",
                                                            bracket.interest_rate.map((r, i) =>
                                                                i === interestIndex ? e.target.value : r
                                                            )
                                                        )
                                                    }
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        handleRemoveInterestRate(tabIndex, bracketIndex, interestIndex)
                                                    }
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        padding: '0 5px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <FaMinus />
                                                </button>
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            onClick={() => handleAddInterestRate(tabIndex, bracketIndex)}
                                            style={{ marginTop: '10px' }}
                                        >
                                            <FaPlus /> Add Interest Rate
                                        </button>
                                    </div>

                                    <div>
                                        <label>Requirement(s):</label>
                                        {bracket.requirement.map((req, reqIndex) => (
                                            <div key={reqIndex} style={{ display: 'flex', gap: '10px' }}>
                                                <input
                                                    type="text"
                                                    value={req}
                                                    onChange={(e) =>
                                                        handleInputChange(
                                                            tabIndex,
                                                            bracketIndex,
                                                            "requirement",
                                                            bracket.requirement.map((r, i) =>
                                                                i === reqIndex ? e.target.value : r
                                                            )
                                                        )
                                                    }
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        handleRemoveRequirement(tabIndex, bracketIndex, reqIndex)
                                                    }
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        padding: '0 5px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <FaMinus />
                                                </button>
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            onClick={() => handleAddRequirement(tabIndex, bracketIndex)}
                                            style={{ marginTop: '10px' }}
                                        >
                                            <FaPlus /> Add Requirement
                                        </button>
                                    </div>

                                    <div>
                                        <label>Tenure:</label>
                                        <input
                                            type="text"
                                            value={bracket.tenure}
                                            onChange={(e) =>
                                                handleInputChange(tabIndex, bracketIndex, "tenure", e.target.value)
                                            }
                                        />
                                    </div>

                                    <div>
                                        <label>Margin:</label>
                                        <input
                                            type="text"
                                            value={bracket.margin}
                                            onChange={(e) =>
                                                handleInputChange(tabIndex, bracketIndex, "margin", e.target.value)
                                            }
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}

                    {/* Add subcategory button for both Create and Edit mode */}
                    <div style={{ marginTop: '20px' }}>
                        {(isCreatingNewLoan || currentLoanData) && (
                            <button
                                type="button"
                                onClick={handleAddSubcategory}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    fontSize: '16px'
                                }}
                            >
                                <FaPlus /> Add Subcategory
                            </button>
                        )}
                    </div>

                    <button type="submit" style={{ marginTop: '20px' }}>Save</button>
                </form>
            </div>
        </Popup>
    );
}
